const Whatsapp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <g clipPath="url(#clip0_3709_14992)">
        <path
          d="M13.1732 1.49023H9.43861C7.63699 1.49023 6.1709 2.95569 6.1709 4.75656C6.1709 6.39931 7.39037 7.7627 8.9718 7.98963V9.42274C8.9718 9.61138 9.0853 9.78182 9.25991 9.8538C9.43211 9.92564 9.63409 9.88713 9.76868 9.75264L11.4992 8.02289H13.1732C14.9748 8.02289 16.472 6.55743 16.472 4.75656C16.472 2.95569 14.9748 1.49023 13.1732 1.49023ZM9.43861 5.22312C9.18074 5.22312 8.9718 5.0142 8.9718 4.7565C8.9718 4.4988 9.18074 4.28988 9.43861 4.28988C9.69642 4.28988 9.90543 4.4988 9.90543 4.7565C9.90543 5.0142 9.69642 5.22312 9.43861 5.22312ZM11.3059 5.22312C11.048 5.22312 10.8391 5.0142 10.8391 4.7565C10.8391 4.4988 11.048 4.28988 11.3059 4.28988C11.5637 4.28988 11.7727 4.4988 11.7727 4.7565C11.7727 5.0142 11.5637 5.22312 11.3059 5.22312ZM13.1732 5.22312C12.9153 5.22312 12.7063 5.0142 12.7063 4.7565C12.7063 4.4988 12.9153 4.28988 13.1732 4.28988C13.431 4.28988 13.6399 4.4988 13.6399 4.7565C13.6399 5.0142 13.431 5.22312 13.1732 5.22312Z"
          fill="#5D6977"
        />
        <path
          d="M11.0259 15.4886C11.7981 15.4886 12.4263 14.8607 12.4263 14.0888V12.2222C12.4263 12.0213 12.2978 11.8432 12.1072 11.7798L9.3129 10.8466C9.17613 10.8006 9.02662 10.8215 8.90627 10.9008L7.71826 11.6923C6.46003 11.0926 4.96706 9.60026 4.36711 8.34256L5.15895 7.15505C5.23871 7.0352 5.25878 6.88529 5.21319 6.7486L4.27956 3.95545C4.21622 3.765 4.03797 3.63651 3.83693 3.63651H1.93854C1.1663 3.63651 0.538086 4.25788 0.538086 5.02979C0.538086 10.4059 5.64748 15.4886 11.0259 15.4886Z"
          fill="#5D6977"
        />
      </g>
      <defs>
        <clipPath id="clip0_3709_14992">
          <rect width="17" height="17" fill="white" transform="translate(0.00683594)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Whatsapp;
